<full-modal-preview class="item-preview-wrapper clr-wrapper">
    <full-modal-preview_container class="item-preview-wrapper__full-modal-preview-container">
        <ng-content select="item-preview-wrapper_custom-content"></ng-content>
        <item-preview-defaults 
            [config]="config" 
            [isItem]="isItem"
        ></item-preview-defaults>
    </full-modal-preview_container>
</full-modal-preview>
